import { LoaderFunctionArgs } from 'react-router-dom';
import { api } from '../lib/api';
import { queryClient } from '../providers/query-client';

export async function formLoader({ params }: LoaderFunctionArgs) {
    const { branchId, admissionId, formId } = params;
    if (branchId && admissionId && formId) {
        return queryClient.fetchQuery({
            queryKey: ['branch', branchId, 'admission', admissionId, 'form', formId],
            queryFn: async () => {
                const { data } = await api.visitForm.get(formId, branchId, admissionId);
                return data;
            },
            staleTime: 60000,
        });
    }
    return null;
}
